"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    badge: {
      paddingLeft: theme.spacing(0.5)
    },
    closeIcon: {
      '&:focus': {
        outline: 'none'
      },
      color: theme.palette.text.secondary,
      fontSize: theme.spacing(2)
    },
    closeIconWrapper: {
      '&:focus': {
        outline: 'none'
      },
      alignItems: 'center',
      display: 'flex',
      marginLeft: 'auto',
      paddingLeft: theme.spacing(1)
    },
    flexItems: {
      alignItems: 'center',
      display: 'flex'
    },
    labelAndSubtitle: {
      alignItems: function alignItems(_ref) {
        var isDynamic = _ref.isDynamic;
        return isDynamic ? 'flex-start' : 'center';
      },
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      textAlign: 'left'
    },
    labelContent: {
      alignItems: 'center',
      display: 'flex',
      fontSize: '14px',
      justifyContent: function justifyContent(_ref2) {
        var isDynamic = _ref2.isDynamic;
        return isDynamic ? 'flex-start' : 'center';
      },
      overflow: 'hidden',
      padding: function padding(_ref3) {
        var isDynamic = _ref3.isDynamic;
        return isDynamic ? 0 : theme.spacing(0, 1);
      },
      width: '100%'
    },
    labelEllipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%'
    },
    labelIcon: {
      height: theme.spacing(3),
      marginRight: 8,
      width: theme.spacing(3)
    },
    subtitle: _objectSpread({}, theme.typography.overline, {
      overflow: 'hidden'
    })
  };
});
var Label = function Label(props) {
  var badge = props.badge,
    dataMetrics = props.dataMetrics,
    fixed = props.fixed,
    icon = props.icon,
    label = props.label,
    mode = props.mode,
    onClose = props.onClose,
    subtitle = props.subtitle,
    tabWidth = props.tabWidth,
    type = props.type;
  var isDynamic = [mode, type].includes('dynamic');
  var classes = useStyles({
    badge: badge,
    fixed: fixed,
    icon: icon,
    isDynamic: isDynamic,
    tabWidth: tabWidth
  });
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(classes.labelContent)
  }, icon && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.labelIcon
  }, icon), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.labelAndSubtitle
  }, label && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.labelEllipsis
  }, label), isDynamic && subtitle && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(classes.subtitle, classes.labelEllipsis)
  }, subtitle)), badge && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.badge
  }, badge), isDynamic && !fixed && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.closeIconWrapper,
    "data-metrics": dataMetrics.closeIcon
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    "aria-label": "Close",
    className: classes.closeIcon,
    color: "secondary",
    onClick: onClose,
    tabIndex: -1
  })));
};
Label.defaultProps = {};
Label.propTypes = process.env.NODE_ENV !== "production" ? {
  badge: _propTypes["default"].element,
  dataMetrics: _propTypes["default"].shape({
    closeIcon: _propTypes["default"].string
  }),
  fixed: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  mode: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  subtitle: _propTypes["default"].string,
  tabWidth: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(['dynamic', 'static'])
} : {};
var _default = Label;
exports["default"] = _default;